import type { AmplifierLocaleKey } from '../../i18n/amplifier/locales';
import type { AmplifierTranslateParams } from '../../i18n/amplifier/amplifierI18nService';

/**
 * protect_mask / alarm_word 共用 BIT0～BIT11（协议 §5.9）：
 * 置 1 = 屏蔽该保护（protect_mask）或该位正在报警（alarm_word）
 */
export const PROTECT_MASK_BITS = {
    IN_FWD_POWER: 0,
    IN_REV_POWER: 1,
    AMP_IN_OVER_POWER: 2,
    AMP_OUT_OVER_POWER: 3,
    OUT_FWD_POWER: 4,
    OUT_REV_POWER: 5,
    OVER_CURRENT: 6,
    OVER_VOLTAGE: 7,
    OVER_TEMP: 8,
    IN_SWR: 9,
    OUT_SWR: 10,
    FREQ_ERROR: 11,
} as const;

/** alarm_word / protect_mask 位图对应的 12 项标签 key（bit 0..11） */
export const AMPLIFIER_ALARM_LABEL_KEYS = [
    '输入正向功率保护',
    '输入反向功率保护',
    '功放管输入过功率保护',
    '功放管输出过功率保护',
    '输出正向功率保护',
    '输出反向功率保护',
    '过流保护',
    '过压保护',
    '过温保护',
    '输入高驻波',
    '输出高驻波',
    '频率误差过大',
] as const satisfies readonly AmplifierLocaleKey[];

/** @deprecated 使用 AMPLIFIER_ALARM_LABEL_KEYS + getActiveAlarmLabels */
export const AMPLIFIER_ALARM_LABELS = AMPLIFIER_ALARM_LABEL_KEYS;

export function getActiveAlarmLabels(
    alarmWord: number,
    t: (key: AmplifierLocaleKey, params?: AmplifierTranslateParams) => string,
): string[] {
    if (!alarmWord) return [];
    return AMPLIFIER_ALARM_LABEL_KEYS.filter((_, i) => (alarmWord & (1 << i)) !== 0).map((key) => t(key));
}

export function hasActiveAlarm(alarmWord: number | undefined | null): boolean {
    return (alarmWord ?? 0) !== 0;
}

export function isProtectMaskBitSet(mask: number | undefined | null, bit: number): boolean {
    return ((mask ?? 0) & (1 << bit)) !== 0;
}

export function toggleProtectMaskBit(mask: number | undefined | null, bit: number, shielded: boolean): number {
    const current = mask ?? 0;
    return shielded ? current | (1 << bit) : current & ~(1 << bit);
}
